/**
 * OWA-specific default attributes added to every sanitization call.
 * These extend the browser's default Sanitizer baseline and the
 * DOMPurify html profile baseline.
 */
export const OWA_ADDITIONAL_ATTRIBUTES: readonly string[] = [
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'content',
    'controls',
    'controlslist',
    'coords',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inputmode',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'naturalheight',
    'naturalwidth',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'originalsrc',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'poster',
    'preload',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'spellcheck',
    'src',
    'srclang',
    'srcset',
    'start',
    'step',
    'style',
    'summary',
    'tabindex',
    'target',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns',
] as const;

/**
 * OWA-specific default elements added to every native Sanitizer call.
 *
 * The native Sanitizer() default baseline is intentionally strict and omits
 * elements that OWA needs for email rendering, compose, and actionable messages.
 * These elements are always added via sanitizer.allowElement() on top of the
 * browser's XSS-safe baseline.
 *
 * Categories:
 * - Email rendering: img, style, font, center
 * - Actionable messages / compose: form, input, button, select, option,
 *   optgroup, label, fieldset, legend, textarea
 * - Media: audio, video, source, picture, track
 * - Legacy formatting (common in older emails): big, strike, tt, nobr, map, area
 */
export const OWA_ADDITIONAL_TAGS: readonly string[] = [
    // Email rendering
    'img',
    'style',
    'font',
    'center',
    // Actionable messages / compose
    'form',
    'input',
    'button',
    'select',
    'option',
    'optgroup',
    'label',
    'fieldset',
    'legend',
    'textarea',
    // Media
    'audio',
    'video',
    'source',
    'picture',
    'track',
    // Legacy formatting
    'big',
    'strike',
    'tt',
    'nobr',
    'map',
    'area',
] as const;
